export default __webpack_public_path__ + "static/media/bd-home.8e60c1ad.png";